import { ShimmerLoadingService } from './../../core/service/shimmer-loading/shimmer-loading.service';
import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import {
  catchError,
  EMPTY,
  Observable,
  throwError
} from 'rxjs';
import { LoaderService } from '../../shared/loader/loader.service';
import { RoutesPath } from '@core/enums';
import { HTTP_CODE } from '@core/enums';
import { AuthService } from '@agenda-customer-ui/data-access';
import { TokenService } from '@core/services';
import { Router } from '@angular/router';

const EXCLUDED_URL_PATTERNS: string[] = [
  'i18n',
  'apiKey',
  'hereapi',
  'googleapis',
  'public',
];

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthService);
  private readonly loaderService = inject(LoaderService);
  private readonly shimmerLoadingService = inject(ShimmerLoadingService);
  private readonly tokenService = inject(TokenService);
  private readonly router = inject(Router);

  private has401ErrorOccurred = false;

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    if (this.has401ErrorOccurred) {
      return throwError(() => new Error('Erro 401 anterior, chamada bloqueada.'));
    }

    const params = this.auth.tokens;

    if (req.url.includes('i18n')) {
      setTimeout(() => {
        this.loaderService.isLoadingTranslate.next(true);
      }, 500);
    }

    const isExcluded = EXCLUDED_URL_PATTERNS.some(pattern => req.url.includes(pattern));

    if (params?.cat !== undefined && !isExcluded) {
      if (this.tokenService.isTokenExpired()) {
        return this.handleAuthError(new HttpErrorResponse({ status: HTTP_CODE.UNAUTHORIZED }));
      }

      const headers = req.headers.set('Authorization', `Bearer ${params.cat}`);
      const newReq = req.clone({ headers });

      return next.handle(newReq).pipe(
        catchError(err => {
          return this.handleAuthError(err);
        })
      );
    }

    return next.handle(req).pipe();
  }

  private handleAuthError(err: HttpErrorResponse): Observable<never> {
    if (err.status === HTTP_CODE.UNAUTHORIZED) {
      this.has401ErrorOccurred = true;
      this.shimmerLoadingService.loading.emit({
        data: true,
      });

      const { country, source } = this.auth.urlInfo;
      this.router.navigate([RoutesPath.LOGOUT_SHELL, country, source]);

      return EMPTY;
    }

    return throwError(() => err);
  }
}
